import React from 'react'

import { SectionTitle } from './styles'

const SectionTitleComponent: React.FC = ({ children }) => {
  return <SectionTitle>{children}</SectionTitle>
}

export default SectionTitleComponent
